import React from 'react'
import ReactDOM from 'react-dom'

import axios from 'axios';
import _ from 'lodash';

const Utils = {
  // -- Previously utils.js --

  _subscribers: {},
  _correlations: {},
  _nextCorrelation: 1,
  axios: axios.create({headers: {'X-CSRFToken': csrf_token}}),  // eslint-disable-line

  apiRequest: (config) => {
    return Utils.axios.request(config);
  },

  apiGet: (url, config) => {
    config = config || {};
    config.url = url;
    return Utils.apiRequest(config);
  },

  apiPost: (url, data, config) => {
    return Utils.axios.post(url, data, config);
  },

  apiPatch: (url, data, config) => {
    return Utils.axios.patch(url, data, config);
  },

  apiDelete: (url, data, config) => {
    return Utils.axios.delete(url, data, config);
  },

  apiPut: (url, data, config) => {
    return Utils.axios.put(url, data, config);
  },

  setCookie: (key, value) => {
    value = JSON.stringify(value);
    // You would think that since getting document.cookie returns *all* cookies that this would
    // reset all cookies, but it doesn't work that way. This just sets the 'key' cookie. Good
    // api, guys.
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
    document.cookie = key + '=' + value + '; path=/; SameSite=None; Secure';
  },
  getCookie: key => {
    let found = document.cookie.split(';').find(row => row.trim().startsWith(key + '='));
    if (!found)  return null;
    try {
      return JSON.parse(found.split('=')[1]);
    } catch(e) {
      return;
    }
  },
}


export default Utils;
